export default __webpack_public_path__ + "static/media/exterior15.fe496fb6.webp";